import React from "react";
import { PiChatsFill } from "react-icons/pi";
import InfiniteScroll from "react-infinite-scroll-component";

import {
  EMPTY_ARRAY_LENGTH,
  inboxReduxConstants,
  CONVERSATION_STATUS_ICON_SIZE,
} from "../../../constants";
import {
  onKeyDownHandler,
  UTCToDateFormatWithMonthNameAndTime,
} from "../../../../../shared";
import { hasMoreListItems } from "../../shared/listPaginationUtility";
import LoadingSpinner from "./loadingSpinner";
import ConversationStatusIcon from "./conversationStatusIcon";

const PreviousConversationsComponent = ({
  spinner,
  selectedConversation,
  getMoreConversationDates,
  previousConversationDates,
  getConversationByPreviousDate,
}) => {
  const isLoading = () => {
    return spinner(inboxReduxConstants.GET_PREVIOUS_CONVERSATION_DATES);
  };

  const renderConversation = () => {
    if (
      previousConversationDates.length === EMPTY_ARRAY_LENGTH &&
      isLoading()
    ) {
      return <LoadingSpinner />;
    }
    if (previousConversationDates.length === EMPTY_ARRAY_LENGTH) {
      return (
        <div className="d-flex justify-content-center p-2">
          No conversation found
        </div>
      );
    }
    return renderConversationCard();
  };

  const renderConversationCard = () => {
    return previousConversationDates?.map((data) => (
      <React.Fragment key={data.orderId}>
        <div
          className={`d-flex align-items-center justify-content-between border-1 border-bottom p-2 pointer previous-conversation ${
            selectedConversation.orderId === data.orderId &&
            "bg-info bg-opacity-10"
          }`}
          data-testid="previous-conversation"
          onClick={() => getConversationByPreviousDate(data)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            onKeyDownHandler(e, () => {
              getConversationByPreviousDate(data);
            });
          }}
        >
          <div>
            <div className="d-flex align-items-start mb-1">
              <p className="bold-6 m-0">
                {data.conversationDate &&
                  UTCToDateFormatWithMonthNameAndTime(data.conversationDate)}
              </p>
            </div>
            <p
              className="text-truncate text-truncate-30ch bold-6 opacity-50 mb-0 pt-1 small"
              title={data.conversationStoreName}
            >
              {data.conversationStoreName}
            </p>
          </div>
          <div className="d-flex align-items-center gap-1">
            {data?.hasMessage && (
              <span className="p-1 rounded bg-secondary bg-opacity-25 d-flex align-items-center text-dark">
                <PiChatsFill size={CONVERSATION_STATUS_ICON_SIZE} />
              </span>
            )}
            <ConversationStatusIcon status={data.conversationStatus} />
          </div>
        </div>
      </React.Fragment>
    ));
  };

  return (
    <>
      {previousConversationDates.length === EMPTY_ARRAY_LENGTH &&
      isLoading() ? (
        <LoadingSpinner />
      ) : (
        <div className="fw-bold lh-1 all-dates custome-sidebar" id="all-dates">
          <InfiniteScroll
            dataLength={previousConversationDates.length}
            next={getMoreConversationDates}
            hasMore={hasMoreListItems(previousConversationDates.length)}
            loader={isLoading() && <LoadingSpinner />}
            scrollableTarget="all-dates"
          >
            {renderConversation()}
          </InfiniteScroll>
        </div>
      )}
    </>
  );
};

export default React.memo(PreviousConversationsComponent);
